import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import axios from 'axios'
import $ from 'jquery'
import * as PDFJS from 'pdfjs-dist/build/pdf'
import workerSrc from 'pdfjs-dist/build/pdf.worker.entry'
PDFJS.GlobalWorkerOptions.workerSrc = workerSrc

const validateIdent = {
  aIdentityCode_City: { // 城市代码列表
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  },
  identityCode_isCardNo (card) { // 检查号码是否符合规范，包括长度，类型
    let reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/ // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    if (reg.test(card) === false) {
      return false
    }
    return true
  },
  identityCode_checkProvince (card) { // 取身份证前两位，校验省份
    let province = card.substr(0, 2)
    if (validateIdent.aIdentityCode_City[province] === undefined) {
      return false
    }
    return true
  },
  identityCode_checkBirthday (card) { // 检查生日是否正确，15位以'19'年份来进行补齐。
    let len = card.length
    // 身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
    if (len === 15) {
      // eslint-disable-next-line camelcase
      let re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/
      // eslint-disable-next-line camelcase
      let arr_data = card.match(re_fifteen) // 正则取号码内所含出年月日数据
      let year = arr_data[2]
      let month = arr_data[3]
      let day = arr_data[4]
      let birthday = new Date('19' + year + '/' + month + '/' + day)
      return validateIdent.identityCode_verifyBirthday('19' + year, month, day, birthday)
    }
    // 身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
    if (len === 18) {
      // eslint-disable-next-line camelcase
      let re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/
      // eslint-disable-next-line camelcase
      let arr_data = card.match(re_eighteen) // 正则取号码内所含出年月日数据
      let year = arr_data[2]
      let month = arr_data[3]
      let day = arr_data[4]
      let birthday = new Date(year + '/' + month + '/' + day)
      return validateIdent.identityCode_verifyBirthday(year, month, day, birthday)
    }
    return false
  },
  identityCode_verifyBirthday (year, month, day, birthday) { // 校验日期 ，15位以'19'年份来进行补齐。
    let now = new Date()
    // eslint-disable-next-line camelcase
    let now_year = now.getFullYear()
    // 年月日是否合理
    if (birthday.getFullYear() === year && (birthday.getMonth() + 1) === month && birthday.getDate() === day) {
      // 判断年份的范围（3岁到150岁之间)
      // eslint-disable-next-line camelcase
      let time = now_year - year
      if (time >= 3 && time <= 150) {
        return true
      }
      return false
    }
    return false
  },
  identityCode_checkParity (card) { // 校验位的检测
    card = validateIdent.identityCode_changeFivteenToEighteen(card) // 15位转18位
    let len = card.length
    if (len === '18') {
      // eslint-disable-next-line no-array-constructor
      let arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2)
      // eslint-disable-next-line no-array-constructor
      let arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2')
      // eslint-disable-next-line one-var
      let cardTemp = 0, i, valnum
      for (i = 0; i < 17; i++) {
        cardTemp += card.substr(i, 1) * arrInt[i]
      }
      valnum = arrCh[cardTemp % 11]
      if (valnum === card.substr(17, 1)) {
        return true
      }
      return false
    }
    return false
  },
  identityCode_changeFivteenToEighteen (card) { // 15位转18位身份证号
    if (card.length === '15') {
      // eslint-disable-next-line no-array-constructor
      let arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2)
      // eslint-disable-next-line no-array-constructor
      let arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2')
      // eslint-disable-next-line one-var
      let cardTemp = 0, i
      card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6)
      for (i = 0; i < 17; i++) {
        cardTemp += card.substr(i, 1) * arrInt[i]
      }
      card += arrCh[cardTemp % 11]
      return card
    }
    return card
  }
}

export default {
  // 导出页面为PDF格式  A4纸的尺寸是595.28 * 841.89
  htmlToPDF: async function (title, elementId, scale) {
    const file = await this.htmlToCanvas(title, elementId, scale)
    return file
  },
  htmlToCanvas: async function (title, elementId, scale) {
    let file = null
    await html2Canvas(document.querySelector(`#${elementId}`),
      {
        allowTaint: true,
        scale: scale || 4
      }
    ).then(canvas => {
      // 一页pdf的宽度
      const pageWidth = 595.28
      // 一页pdf的高度
      const pageHeight = 841.89
      // html内容真实宽度
      const contentWidth = canvas.width
      // html内容真实高度
      const contentHeight = canvas.height
      // html内容在pdf中高度
      let contentPdfHeight = pageWidth / contentWidth * contentHeight
      // 页面偏移量
      let position = 0
      // html页面生成的canvas在pdf中图片的宽高
      let imgWidth = pageWidth
      let imgHeight = pageWidth / contentWidth * contentHeight
      let pageData = canvas.toDataURL('image/jpeg', 1.0)
      let pdf = new JsPDF('', 'pt', 'a4')
      if (contentPdfHeight < pageHeight) {
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
      } else {
        while (contentPdfHeight > 0) {
          pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
          contentPdfHeight -= pageHeight
          position -= pageHeight
          if (contentPdfHeight > 0) {
            pdf.addPage()
          }
        }
      }
      // // 下载生成的PDF文件
      // pdf.save(title + '.pdf')
      // // 在新窗口查看生成的PDF文件
      // pdf.output('dataurlnewwindow')
      // 将pdf输入为base64格式的字符串
      const buffer = pdf.output('datauristring')
      // 将base64格式的字符串转换为file文件
      file = this.dataURLtoFile(buffer, `${title}.pdf`)
    })
    return file
  },
  // 将base64转换为文件对象
  dataURLtoFile: function (dataurl, filename) {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    // 转换成file对象
    return new File([u8arr], filename, {type: mime})
  },
  // 加载远程pdf文件并转为base64
  pdfToBase64: async function (pdfUrl) {
    let fileData = null
    fileData = await axios({
      method: 'get',
      url: pdfUrl,
      responseType: 'blob'
    })
    return new Promise((resolve, reject) => {
      if (fileData && fileData.data) {
        const blob = new Blob([fileData.data], { type: 'application/pdf' })
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      }
    })
  },
  // 加载远程pdf文件并转为Blob
  pdfToBlob: async function (pdfUrl) {
    let fileData = null
    fileData = await axios({
      method: 'get',
      url: pdfUrl,
      responseType: 'blob'
    })
    return new Promise((resolve) => {
      if (fileData && fileData.data) {
        const blob = new Blob([fileData.data], { type: 'application/pdf' })
        resolve(blob)
      }
    })
  },
  // 利用pdf.js加载远程pdf文件转为图片
  pdfToImage: async function (pdfUrl, canvasId) {
    const scale = 5
    const canvasArray = []
    await PDFJS.getDocument(pdfUrl).promise.then(async function (pdf) {
      const pages = pdf.numPages
      for (let i = 1; i <= pages; i++) {
        await pdf.getPage(i).then(function (page) {
          const canvas = document.createElement('canvas')
          canvas.id = `${canvasId}${i}`
          const viewport = page.getViewport(scale)
          const context = canvas.getContext('2d')
          canvas.width = viewport.width
          canvas.height = viewport.height
          const renderContext = {
            canvasContext: context,
            viewport: viewport
          }
          page.render(renderContext)
          canvasArray.push(canvas)
        })
      }
    })
    return canvasArray
  },
  // 校验电话号码
  isPhone: function (phone) {
    if (!(/^1[3456789]\d{9}$/.test(phone))) {
      return false
    }
    return true
  },
  // 身份证号码检验主入口
  identityCodeValid (card) {
    let pass = true
    let sex = ''
    console.log(sex)
    // 是否为空
    if (pass && card === '') {
      pass = false
    }
    // 校验长度，类型
    if (pass && validateIdent.identityCode_isCardNo(card) === false) {
      pass = false
    }
    // 检查省份
    if (pass && validateIdent.identityCode_checkProvince(card) === false) {
      pass = false
    }
    // 校验生日
    if (pass && validateIdent.identityCode_checkBirthday(card) === false) {
      pass = false
    }
    // 检验位的检测
    if (pass && validateIdent.identityCode_checkParity(card) === false) {
      pass = false
    }
    if (pass) {
      let iCard = validateIdent.identityCode_changeFivteenToEighteen(card)
      if (parseInt(iCard.charAt(16)) % 2 === 0) {
        sex = '0' // 女生
      } else {
        sex = '1' // 男生
      }
      return true
    } else {
      return false
    }
  },
  // 只能输入一个数字和小数点
  formatDecimal (str, num) { // str当前输入值，num是想要保留的小数位数
    str = String(str)
    if (!str.trim()) {
      return str
    }
    var len1 = str.substr(0, 1)
    var len2 = str.substr(1, 1)
    // 如果第一位是0，第二位不是点，就用数字把点替换掉
    if (str.length > 1 && len1 === 0 && len2 !== '.') {
      str = str.substr(1, 1)
    }
    // 第一位不能是.
    if (len1 === '.') {
      str = ''
    }
    // 限制只能输入一个小数点
    if (str.indexOf('.') !== -1) {
      var str_ = str.substr(str.indexOf('.') + 1)
      if (str_.indexOf('.') !== -1) {
        str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
      }
    }
    // 正则替换
    str = str.replace(/[^\d^.]+/g, '') // 保留数字和小数点
    if (num || num === 0) {
      var rest = str.split('.')[1]
      if (rest && rest.length > num) {
        rest = rest.substr(0, num)
        str = str.split('.')[0] + '.' + rest
      }
    }
    return str
  },
  // 格式化身份证号，显示前三位和后四位，中间用*代替
  formatIdCard (idCard) {
    if (!idCard) {
      return ''
    }
    const length = idCard.length
    const topThree = idCard.substr(0, 3)
    const lastThree = idCard.substr(length - 4)
    let other = ''
    for (let i = 0; i < length - 7; i++) {
      other += '*'
    }
    return `${topThree}${other}${lastThree}`
  },
  // 根据类型获取字典数据
  getDicByType (type) {
    const dicList = {
      // 性别
      sex: [
        {value: '0', label: '男'},
        {value: '1', label: '女'},
        {value: '2', label: '未知'}
      ],
      // 文化程度
      education: [
        {value: '1', label: '未知'},
        {value: '2', label: '小学'},
        {value: '3', label: '初中'},
        {value: '4', label: '高中'},
        {value: '5', label: '大学及以上'}
      ],
      // 糖代谢状态
      glucometabolicState: [
        {value: '0', label: '正常'},
        {value: '1', label: '糖尿病前期'},
        {value: '2', label: '1型糖尿病'},
        {value: '3', label: '2型糖尿病'},
        {value: '4', label: '妊娠糖尿病'}
      ],
      // 干预/治疗方式
      treatment: [
        {value: '1', label: '无干预或注意生活方式'},
        {value: '2', label: '生活方式或口服药干预'},
        {value: '3', label: '胰岛素'},
        {value: '4', label: '口服药无SU/口服药SU'},
        {value: '5', label: '口服药+基础胰岛素'},
        {value: '6', label: '口服药+餐时胰岛素'},
        {value: '7', label: '口服药+预混胰岛素'},
        {value: '8', label: '口服药+GLP-1RA'},
        {value: '9', label: 'GLP-1RA'},
        {value: '10', label: '基础胰岛素'},
        {value: '11', label: '预混胰岛素'},
        {value: '12', label: '基础+餐时胰岛素'},
        {value: '13', label: '生活方式/胰岛素'}
      ],
      // 特殊类型糖尿病
      specialGlu: [
        {value: 0, label: '否'},
        {value: 1, label: '是'}
      ],
      // 所有测量时段
      measurePeriodList: {
        'KF': '空腹',
        'CQ': '餐前',
        'CH': '餐后',
        'ZCQ': '早餐前',
        'ZCH': '早餐后',
        'WUCQ': '午餐前',
        'WUCH': '午餐后',
        'WACQ': '晚餐前',
        'WACH': '晚餐后',
        'SQ': '睡前',
        'LC': '凌晨',
        'LC3': '凌晨三点',
        'SJ': '随机',
        'WU': '无'
      },
      // 统计维度
      statisticsTypeList: [
        {value: '1', label: '按月统计'},
        {value: '2', label: '按季度统计'},
        {value: '3', label: '按半年统计'},
        {value: '4', label: '按年统计'}
      ],
      // 业务类型
      businessTypeDic: [
        {value: 1, label: '新增'},
        {value: 2, label: '编辑'},
        {value: 3, label: '删除'},
        {value: 4, label: '授权'},
        {value: 5, label: '导出'},
        {value: 6, label: '导入'},
        {value: 7, label: '强退'},
        {value: 8, label: '生成代码'},
        {value: 9, label: '清空数据'},
        {value: 10, label: '登录'},
        {value: 0, label: '其它'}
      ],
      // 操作类型
      operatorType: [
        {value: 0, label: '其它'},
        {value: 1, label: '后台用户'},
        {value: 2, label: '手机端用户'}
      ]
    }
    return dicList[type]
  },
  // 获取性别名字
  getSexName (sex) {
    let sexName = ''
    if (sex === '0') {
      sexName = '男'
    } else if (sex === '1') {
      sexName = '女'
    } else if (sex === '2') {
      sexName = '未知'
    } else {
      sexName = ''
    }
    return sexName
  },
  // 获取糖代谢状态名称
  getGlucometabolicStateName (state) {
    let stateName = ''
    const dicList = this.getDicByType('glucometabolicState')
    dicList.forEach(item => {
      if (String(item.value) === String(state)) {
        stateName = item.label
      }
    })
    return stateName
  },
  // 获取干预/治疗方式名称
  getTreatmentName (treatment) {
    let treatmentName = ''
    const dicList = this.getDicByType('treatment')
    dicList.forEach(item => {
      if (String(item.value) === String(treatment)) {
        treatmentName = item.label
      }
    })
    return treatmentName
  },
  // 格式化测量值
  formatMeasureValue (measureValue) {
    if (measureValue === 990) {
      return 'LO'
    } else if (measureValue === 991) {
      return 'HI'
    } else if (measureValue === 996) {
      return '食晚'
    } else if (measureValue === 997) {
      return '外出'
    } else if (measureValue === 998) {
      return '拒测'
    } else if (measureValue === 999) {
      return '其他'
    } else {
      return measureValue ? parseFloat(measureValue).toFixed(1) : ''
    }
  },
  // 根据最大血糖值计算Y轴最大刻度
  computeYaxisMaxValue: function (chartData, defaultMaxValue) {
    let maxValue = 0
    chartData.forEach(item => {
      let {measureValue} = item
      measureValue = parseInt(measureValue)
      if (measureValue > maxValue) {
        maxValue = measureValue
      }
    })
    maxValue += 5
    if (maxValue % 5 !== 0) {
      maxValue = (parseInt(maxValue / 5) + 1) * 5
    }
    if (maxValue < defaultMaxValue) {
      maxValue = defaultMaxValue
    }
    return maxValue
  },
  // 获取默认时段名称
  getMeasurePeriodName (objName) {
    const dicList = this.getDicByType('measurePeriodList')
    return dicList[objName]
  },
  // 基于1920 * 1080的分辨率，根据页面宽度，动态设置echarts图表中的字体
  getChartFontSize: function (fontSize) {
    // 获取系统的缩放比例
    let devicePixelRatio = 1
    const screen = window.screen
    const ua = navigator.userAgent.toLowerCase()
    if (window.devicePixelRatio !== undefined) {
      devicePixelRatio = window.devicePixelRatio
    } else if (~ua.indexOf('msie')) {
      if (screen.deviceXDPI && screen.logicalXDPI) {
        devicePixelRatio = screen.deviceXDPI / screen.logicalXDPI
      }
    } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
      devicePixelRatio = window.outerWidth / window.innerWidth
    }
    // 当前网页的宽度
    const windowWidth = $(window).width()
    // 当前网页宽度与1920的比率
    const ratio = windowWidth / 1920
    // 根据比率和缩放设置实际显示的字体大小
    let realFontSize = fontSize * ratio * devicePixelRatio
    // 设置最小12px
    if (realFontSize < 12) {
      realFontSize = 12
    }
    return realFontSize
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js